import { Styles } from '@orcar/common-d2c';
import GalaxyLogo from '@/assets/img/galaxy_logo.png';
import Logo from '@/assets/img/jejuro_block_logo.png';
import { useBusinessProfile } from '@/hooks/useSiteProfile';
import CompanyInfoSection from './components/CompanyInfoSection';
import LinkButtonSection from './components/LinkButtonSection';
import SocialLinks from './components/SocialLinks';
import * as S from './styles';

const Footer = () => {
  const { rentalOperators, copyright } = useBusinessProfile();
  return (
    <S.Wrapper>
      <S.InnerWrapper>
        <S.TopSection>
          <S.LeftSection>
            <S.FooterLogos>
              <img src={Logo} width={151} height={34} alt='로고' />
              <img src={GalaxyLogo} width={90} alt='갤럭시렌트카 로고' />
            </S.FooterLogos>
            <CompanyInfoSection />
            {/* <CompanyInfoSection isOrcar /> */}
            <SocialLinks />
          </S.LeftSection>
          <S.RightSection>
            <LinkButtonSection />
          </S.RightSection>
        </S.TopSection>
      </S.InnerWrapper>
      <S.BottomSection>
        {rentalOperators && (
          <S.RentalOperator>대여사업자 : {rentalOperators}</S.RentalOperator>
        )}
        {copyright && (
          <S.InfoContent color={Styles.COLOR.GREY_02} font={Styles.FONT.B2}>
            {copyright}
          </S.InfoContent>
        )}
      </S.BottomSection>
    </S.Wrapper>
  );
};

export default Footer;
